import { releaseInfo } from '../config/release';

export function ReleaseMeta(): JSX.Element {
  return (
    <div
      className="text-center text-xs leading-tight text-gray-500 dark:text-gray-400"
      aria-label={`RetroJet version ${releaseInfo.version}, released ${releaseInfo.formattedReleasedAt}`}
    >
      <div className="font-medium">RetroJet v{releaseInfo.version}</div>
      <time dateTime={releaseInfo.releasedAt}>
        Released {releaseInfo.formattedReleasedAt}
      </time>
    </div>
  );
}
